<!-- BaseButton.vue -->
<template>
  <button
    :class="[
      'button',
      buttonClass,
      disabled || loading ? 'disabled-button' : '',
    ]"
    @click="$emit('click')"
    :disabled="disabled || loading"
  >
    <div v-if="loading" class="loader-container">
      <div class="loader"></div>
    </div>
    <span v-if="!loading">
      <slot>{{ text }}</slot>
    </span>
    <div v-if="hasArrow" class="arrow-container">
      <img src="/path/to/arrow.svg" alt="Arrow" />
    </div>
  </button>
</template>

<script>
export default {
  name: "BaseButton",
  props: {
    text: { type: String, default: "" },
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    buttonClass: { type: String, default: "modal-button" },
    cornerColor: { type: String, default: "#15CA5C" },
    hasArrow: { type: Boolean, default: false },
    useFrame: { type: Boolean, default: true },
    wrapperClass: { type: String, default: "" },
    wrapperStyle: { type: Object, default: () => ({}) },
  },
  emits: ["click"],
};
</script>

<style lang="scss" scoped>
.modal-button-wrapper {
  border: 1px solid #ffffff1a;
  padding: 4px;
  max-width: 160px;
  width: 100%;
  margin: 0 auto;
}

.button {
  font-family: "Roboto", sans-serif;
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #ffffff57;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  padding: 7px 14px;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  text-align: center;
  background-color: transparent;
  color: #9d1616;
  text-transform: uppercase;
  border-radius: 80px;
  max-width: 100%;

  &.w-78 {
    width: 78px;
  }
  &.w-326 {
    width: 326px;
  }
  &.w-142 {
    width: 142px;
  }
  &:hover {
    opacity: 1;
  }
  &.small {
    padding: 10px;
  }
  &.big {
    font-family: "Montserrat", sans-serif;
    font-size: 32px;
    padding: 14px;
    line-height: 38px;
    border: 0;
    color: #080202;
  }
  &.blue {
    background: linear-gradient(#0c165b, #16279e);
    border: 1px solid #233ce5;

    &:hover {
      background: linear-gradient(#233ce5, #16279e);
    }
  }
  &.gray {
    background: #24292b;
    border: 1px solid #ffffff57;

    &:hover {
      background: #9d1616;
      border: 1px solid #ffffff57;
      color: #24292b;
    }
  }
  &.green {
    background: linear-gradient(180deg, #9ef23a 0%, #6cc025 100%);
    border-bottom: 3px solid #387900;

    &:hover {
      background: linear-gradient(180deg, #6cc025 0%, #9ef23a 100%);
    }
  }

  &.yellow {
    background: linear-gradient(180deg, #9d1616 0%, #f69800 100%);
    border-bottom: 3px solid #a36500;

    &:hover {
      background: linear-gradient(180deg, #f69800 0%, #9d1616 100%);
    }
  }
  &.w-82 {
    width: 82px;
  }
  &.w-106 {
    width: 106px;
  }
  &.w-200 {
    width: 200px;
  }
}

.disabled-button {
  opacity: 0.5;
  cursor: not-allowed;

  pointer-events: none;
}

// .loader-container {
//     display: flex;
//     align-items: center;
//     justify-content: center;

//     width: 100%;

//     height: 100%;

// }

// .loader {
//     border: 4px solid #f3f3f3;

//     border-top: 4px solid #3498db;

//     border-radius: 50%;
//     width: 20px;
//     height: 20px;
//     animation: spin 2s linear infinite;
// }

// @keyframes spin {
//     0% {
//         transform: rotate(0deg);
//     }

//     100% {
//         transform: rotate(360deg);
//     }
// }

.arrow-container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  margin-left: 8px;
}

.arrow-container img {
  width: 20px;

  height: 20px;
}

.cancel-button {
  background-color: #ff0000;
  color: white;
}

.primary-button {
  background-color: #007bff;

  color: white;
}
</style>
